"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSalesmanSupplies = void 0;
const Base_1 = require("./Base");
exports.GetSalesmanSupplies = {
    url: Base_1.URL_BASE + "/GetSalesmanSupplies",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetSalesmanSupplies.js.map